import React, { useState } from 'react';
import useSWR from 'swr';
import getSymbolFromCurrency from 'currency-symbol-map';

import PlanCard from '../../PlanCard';
import { getAverageResults } from '@services/insights';
import { ConfirmLIAModal } from '../../Modals';
import { updateLiaPlan } from '../utils';
import styles from '../LocalAdsOverview.module.scss';

const budgets = [3, 5, 10, 15, 20, 30, 50, 80];

const LiaCards = ({ shop, revalidate }) => {
	const [confirmationModal, setConfirmationModal] = useState(0);
	// Deliberately not suspense: the aggregate is an estate-wide read on the backend
	// (average-results handler) and only feeds the "impressions per week" line, so the
	// picker renders straight away and the estimate fills in — or is hidden if the call
	// fails, instead of the whole picker falling into the ErrorBoundary (NEA-6254). A
	// loaded estimate is kept through a failed background revalidation (SWR keeps `data`
	// and only sets `error`), so the cards don't blank on a transient refetch error.
	const { data: averageResults, error: averageResultsError } = useSWR('local-ads-avg-results', getAverageResults);
	const currencySymbol = getSymbolFromCurrency(shop.billingCurrency || 'GBP');

	return (
		<>
			<h3>Select a daily budget</h3>
			<div className={styles.plans} data-cy="plus-plan-cards-wrapper">
				{budgets.map((budget) => (
					<PlanCard
						key={budget}
						id={shop.id}
						dailyAmount={budget}
						choosePlan={async () => {
							await updateLiaPlan({ budget, shop });
							setConfirmationModal(budget);
						}}
						currencySymbol={currencySymbol}
						averageResults={averageResults ?? (averageResultsError ? null : undefined)}
					/>
				))}
			</div>
			<ConfirmLIAModal
				show={confirmationModal > 0}
				close={() => {
					setConfirmationModal(0);
					revalidate();
				}}
			/>
		</>
	);
};

export default LiaCards;
